"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _constant = require("../constant");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SFCNodeTypeContent',
  props: {
    dialogData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    getItemDataList: function getItemDataList(group) {
      return group.productStationItemTraceList && group.productStationItemTraceList.length > 0 ? group.productStationItemTraceList[0].itemDataList || [] : [];
    },
    onNodeTypeClick: function onNodeTypeClick() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      this.$emit.apply(this, ['click'].concat(args));
    }
  }
};